import React, { useEffect, useState } from 'react'
import { ExtendableSelectField, IExtendableSelectProps } from '../../../../Components/formComponents'
import { axios_api } from '../../../../api'

interface IPaymentPaidVendorSelectProps {
    value: string
    onChange: IExtendableSelectProps["onChange"]
    error?: string
}

export const PaymentPaidVendorSelect: React.FC<IPaymentPaidVendorSelectProps> = ({
    value,
    onChange,
    error
}) => {
    const [accountingVendors, setAccountingVendors] = useState<IExtendableSelectProps["options"]>([])

    useEffect(() => {
        axios_api.get(`/accounting/get-accounting-vendor`).then((res) => {
            const response = res.data.data as { vendor_uuid: string, vendor_name: string }[]
            const filterData: IExtendableSelectProps["options"] = response.map((vendor) => {
                return { label: vendor.vendor_name, value: vendor.vendor_name }
            })
            setAccountingVendors(filterData)
        })
    }, [])

    return (
        <ExtendableSelectField
            label="Vendor"
            value={value}
            onChange={onChange}
            options={accountingVendors}
            error={error}
        />
    )
}
